import React from "react";
import { useQuery } from "@apollo/client";
import { ActiveUserDevices, hash } from "../gql/ActiveUserDevices";
import {
  UserDevicesSubscription,
  hash as hash2,
} from "../gql/ActiveUserDevicesSubscription";
import ListGroup from "react-bootstrap/ListGroup";

const UserDevices = ({ userId, setDeselected, setCurrent }) => {
  const { data, loading, error, subscribeToMore } = useQuery(
    ActiveUserDevices,
    {
      variables: {
        userId: userId,
      },
      fetchPolicy: "network-only",
      nextFetchPolicy: "network-only",
      context: { headers: { "X-Trust-Key": hash } },
    }
  );

  subscribeToMore({
    document: UserDevicesSubscription,
    variables: {
      userId: userId,
    },
    updateQuery: (prev) => {
      return prev;
    },
    context: { headers: { "X-Trust-Key": hash2 } },
  });

  if (loading) return;

  if (error) return;

  if (data) {
    setCurrent(data?.allUserDevices?.nodes);
    return (
      <div style={{ width: "300px", border: "1px solid grey" }}>
        {data?.allUserDevices?.nodes?.length > 0 ? (
          <ListGroup variant="flush">
            {data.allUserDevices.nodes.map((devices) => (
              <ListGroup.Item
                action
                eventKey={devices.id}
                onClick={() => setDeselected(devices.id)}
              >
                {devices.deviceByDeviceId.deviceName}
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <p
            className="row-sm-1 mb-0"
            style={{ textAlign: "center", color: "red" }}
          >
            Please assign devices.
          </p>
        )}
      </div>
    );
  }
};

export default UserDevices;
